import { render, staticRenderFns } from "./AddRepresentative.vue?vue&type=template&id=6f8f8fed&scoped=true"
import script from "./AddRepresentative.vue?vue&type=script&lang=js"
export * from "./AddRepresentative.vue?vue&type=script&lang=js"
import style0 from "./AddRepresentative.vue?vue&type=style&index=0&id=6f8f8fed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f8fed",
  null
  
)

export default component.exports